import styled from 'styled-components';

export const PincodeContainer = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding-left: 16px;
`;

export const LocationIconWrapper = styled.div`
    display: flex;
    width: 24px;
    height: 24px;
    padding: 3.5px 5.144px;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;
`;

export const PincodeTitle = styled.span`
    color: #121212;
    font-size: 14px;
    line-height: 20px;
`;

export const PincodeValue = styled.span`
    color: #121212;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
`;

export const EditIconWrapper = styled.div`
    width: 16px;
    height: 16px;
    aspect-ratio: 1/1;
`;
